/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_See_ReportInputs */

const en_us2_progress_report_see_report = /** @type {(inputs: Progress_Report_See_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See report`)
};

const pt_br2_progress_report_see_report = /** @type {(inputs: Progress_Report_See_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver relatório`)
};

const es_419_progress_report_see_report = /** @type {(inputs: Progress_Report_See_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver informe`)
};

const pt_pt2_progress_report_see_report = /** @type {(inputs: Progress_Report_See_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver relatório`)
};

const fr_fr2_progress_report_see_report = /** @type {(inputs: Progress_Report_See_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le bilan`)
};

const de_de2_progress_report_see_report = /** @type {(inputs: Progress_Report_See_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht ansehen`)
};

const it_it2_progress_report_see_report = /** @type {(inputs: Progress_Report_See_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi report`)
};

/**
* | output |
* | --- |
* | "See report" |
*
* @param {Progress_Report_See_ReportInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_see_report = /** @type {((inputs?: Progress_Report_See_ReportInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_See_ReportInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_see_report(inputs)
	if (locale === "es-419") return es_419_progress_report_see_report(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_see_report(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_see_report(inputs)
	if (locale === "de-DE") return de_de2_progress_report_see_report(inputs)
	if (locale === "it-IT") return it_it2_progress_report_see_report(inputs)
	return en_us2_progress_report_see_report(inputs)
});
export { progress_report_see_report as "progress-report.see_report" }